(function () {
  var PROMOS = [
    {
      name: 'MudMixer Evolution Bundle',
      startsAt: '2026-08-27T05:01:00Z',
      endsAt: '2026-10-01T04:59:00Z',
      triggerProductHandles: ['mudmixer-evolution'],
      giftVariantIds: [44411663876296, 43102006018248],
      giftVariantExclusions: [
        {
          variantId: 44411663876296,
          whenTriggerHandlesInCart: ['ultimate-bundle-evolution'],
        },
      ],
    },
    {
      name: 'Ultimate Bundle Evolution Cover Gift',
      startsAt: '2026-08-27T05:01:00Z',
      endsAt: '2026-10-01T04:59:00Z',
      triggerProductHandles: ['ultimate-bundle-evolution'],
      giftVariantIds: [43102006018248],
    },
  ];

  var isReconciling = false;
  var reconcileTimer = null;
  var lastCart = null;
  var dismissedGiftStorageKey = 'bundlePromoDismissedGiftVariants';

  function getDismissedGiftVariantIds() {
    try {
      return JSON.parse(window.sessionStorage.getItem(dismissedGiftStorageKey) || '[]');
    } catch (error) {
      return [];
    }
  }

  function setDismissedGiftVariantIds(variantIds) {
    try {
      window.sessionStorage.setItem(dismissedGiftStorageKey, JSON.stringify(variantIds));
    } catch (error) {
      // Storage can be unavailable in private browsing; the promo still works without dismissal memory.
    }
  }

  function dismissGiftVariant(variantId) {
    var dismissed = getDismissedGiftVariantIds();
    if (dismissed.indexOf(Number(variantId)) !== -1) return;
    dismissed.push(Number(variantId));
    setDismissedGiftVariantIds(dismissed);
  }

  function clearDismissedGiftVariants() {
    setDismissedGiftVariantIds([]);
  }

  function isActivePromo(promo) {
    var now = Date.now();
    var start = promo.startsAt ? Date.parse(promo.startsAt) : null;
    var end = promo.endsAt ? Date.parse(promo.endsAt) : null;

    if (start && now < start) return false;
    if (end && now > end) return false;
    return true;
  }

  function getActivePromos(cart) {
    return PROMOS.filter(function (promo) {
      if (!isActivePromo(promo)) return false;

      return cart.items.some(function (item) {
        return promo.triggerProductHandles.indexOf(item.handle) !== -1;
      });
    });
  }

  function getAutoGiftLines(cart) {
    return cart.items.filter(function (item) {
      return item.properties && item.properties._bundle_promo_gift;
    });
  }

  function cartHasVariant(cart, variantId) {
    return cart.items.some(function (item) {
      return Number(item.variant_id) === Number(variantId);
    });
  }

  function getVariantQuantity(cart, variantId) {
    return cart.items.reduce(function (quantity, item) {
      if (Number(item.variant_id) !== Number(variantId)) return quantity;
      return quantity + item.quantity;
    }, 0);
  }

  function getTriggerQuantity(cart, promo) {
    return cart.items.reduce(function (quantity, item) {
      if (promo.triggerProductHandles.indexOf(item.handle) === -1) return quantity;
      return quantity + item.quantity;
    }, 0);
  }

  function getAutoGiftLine(cart, promo, variantId) {
    return cart.items.find(function (item) {
      return (
        Number(item.variant_id) === Number(variantId) &&
        item.properties &&
        item.properties._bundle_promo_gift === promo.name
      );
    });
  }

  function cartHasAnyHandle(cart, handles) {
    return cart.items.some(function (item) {
      return handles.indexOf(item.handle) !== -1;
    });
  }

  function shouldSyncGiftVariant(promo, cart, variantId) {
    return !(promo.giftVariantExclusions || []).some(function (exclusion) {
      return (
        Number(exclusion.variantId) === Number(variantId) &&
        cartHasAnyHandle(cart, exclusion.whenTriggerHandlesInCart || [])
      );
    });
  }

  function cartHasTriggerProduct(cart) {
    return PROMOS.some(function (promo) {
      return cart.items.some(function (item) {
        return promo.triggerProductHandles.indexOf(item.handle) !== -1;
      });
    });
  }

  function rememberManuallyRemovedGifts(previousCart, currentCart) {
    if (!previousCart || !cartHasTriggerProduct(currentCart)) return;

    getAutoGiftLines(previousCart).forEach(function (item) {
      if (!cartHasVariant(currentCart, item.variant_id)) {
        dismissGiftVariant(item.variant_id);
      }
    });
  }

  function publishCartUpdate(cart) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'bundle-promo-gifts',
        cartData: cart,
      });
    }
  }

  function postCartAdd(items) {
    if (!items.length) return Promise.resolve(null);

    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: items }),
    });
  }

  function postCartUpdate(updates) {
    if (!Object.keys(updates).length) return Promise.resolve(null);

    return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ updates: updates }),
    });
  }

  function syncGiftVariants(promo, cart, options) {
    options = options || {};

    var dismissedGiftVariantIds = getDismissedGiftVariantIds();
    var triggerQuantity = getTriggerQuantity(cart, promo);
    var updates = {};
    var itemsToAdd = [];

    promo.giftVariantIds.forEach(function (variantId) {
      if (dismissedGiftVariantIds.indexOf(Number(variantId)) !== -1) return;

      var autoGiftLine = getAutoGiftLine(cart, promo, variantId);
      if (!shouldSyncGiftVariant(promo, cart, variantId)) {
        if (autoGiftLine) updates[autoGiftLine.key] = 0;
        return;
      }

      var desiredAutoGiftQuantity = triggerQuantity;

      if (autoGiftLine) {
        if (autoGiftLine.quantity !== desiredAutoGiftQuantity) {
          updates[autoGiftLine.key] = desiredAutoGiftQuantity;
        }
        return;
      }

      if (desiredAutoGiftQuantity > 0 && options.addNewGifts !== false) {
        itemsToAdd.push({
          id: variantId,
          quantity: desiredAutoGiftQuantity,
          properties: {
            _bundle_promo_gift: promo.name,
          },
        });
      }
    });

    if (!itemsToAdd.length && !Object.keys(updates).length) return Promise.resolve(cart);

    return postCartUpdate(updates).then(function () {
      return postCartAdd(itemsToAdd);
    }).then(function () {
      return fetchCart();
    });
  }

  function removeAutoGiftLines(cart) {
    var giftLines = getAutoGiftLines(cart);
    if (!giftLines.length) return Promise.resolve(cart);

    var updates = {};
    giftLines.forEach(function (item) {
      updates[item.key] = 0;
    });

    return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ updates: updates }),
    }).then(function () {
      return fetchCart();
    });
  }

  function removeInactiveAutoGiftLines(cart, activePromos) {
    var activePromoNames = activePromos.map(function (promo) {
      return promo.name;
    });
    var giftLines = getAutoGiftLines(cart).filter(function (item) {
      return activePromoNames.indexOf(item.properties._bundle_promo_gift) === -1;
    });
    if (!giftLines.length) return Promise.resolve(cart);

    var updates = {};
    giftLines.forEach(function (item) {
      updates[item.key] = 0;
    });

    return postCartUpdate(updates).then(function () {
      return fetchCart();
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (response) {
      return response.json();
    });
  }

  function reconcileGifts(options) {
    options = options || {};

    if (isReconciling) return Promise.resolve();
    isReconciling = true;

    return fetchCart()
      .then(function (cart) {
        rememberManuallyRemovedGifts(lastCart, cart);

        var activePromos = getActivePromos(cart);
        if (!activePromos.length) {
          clearDismissedGiftVariants();
          return removeAutoGiftLines(cart);
        }
        return removeInactiveAutoGiftLines(cart, activePromos).then(function (updatedCart) {
          return activePromos.reduce(function (chain, promo) {
            return chain.then(function (currentCart) {
              return syncGiftVariants(promo, currentCart, { addNewGifts: options.addMissingGifts !== false });
            });
          }, Promise.resolve(updatedCart));
        });
      })
      .then(function (cart) {
        if (cart) {
          lastCart = cart;
          publishCartUpdate(cart);
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        isReconciling = false;
      });
  }

  function scheduleReconcile(options) {
    window.clearTimeout(reconcileTimer);
    reconcileTimer = window.setTimeout(function () {
      reconcileGifts(options);
    }, 150);
  }

  function getCartMutationType(url) {
    url = String(url || '');
    if (url.indexOf('/cart/add') !== -1) return 'add';
    if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) return 'change';
    return null;
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var request = arguments[0];
    var url = typeof request === 'string' ? request : request && request.url;

    return originalFetch.apply(this, arguments).then(function (response) {
      var mutationType = getCartMutationType(url);
      if (!isReconciling && mutationType === 'add') scheduleReconcile({ addMissingGifts: true });
      if (!isReconciling && mutationType === 'change') scheduleReconcile({ addMissingGifts: false });
      return response;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleReconcile({ addMissingGifts: true });
    });
  } else {
    scheduleReconcile({ addMissingGifts: true });
  }
})();
